import React, { FC } from 'react'
import form from 'styles/components/form.module.scss'
import { ShoppingBagType } from 'types/store'
import { Spacer } from 'components/Utility'
import { ShoppingBagEditorRow } from './index'
import { TextButton } from 'components/Button'
import { FlexRow } from 'components/Flex'
import { Caution } from 'components/Typography'

type Props = {
  addShoppingBagRow: () => void
  deleteShoppingBagRow: (index: number) => void
  handleShoppingBags: (index: number, name: string, price: number) => void
  shoppingBags: ShoppingBagType[]
}

const ShoppingBagEditor: FC<Props> = (props) => {
  const { addShoppingBagRow, deleteShoppingBagRow, handleShoppingBags, shoppingBags } = props

  return (
    <div id={'shopping-bag-form'}>
      {shoppingBags.length > 0 && (
        <div className={form.shoppingBag__row__label}>
          <p>レジ袋サイズ</p>
          <p>レジ袋価格(税抜)</p>
        </div>
      )}
      {shoppingBags.map((shoppingBag, index) => (
        <>
          <ShoppingBagEditorRow
            key={shoppingBag.name}
            deleteShoppingBagRow={deleteShoppingBagRow}
            handleShoppingBags={handleShoppingBags}
            index={index}
            name={shoppingBag.name}
            price={shoppingBag.price}
          />
          {shoppingBag.price > 1000 && (
            <>
              <Caution caution={'レジ袋オプションは1,000円以内に設定してください'} size={'small'} />
              <Spacer size={8} />
            </>
          )}
        </>
      ))}
      <Spacer size={8} />
      <FlexRow justifyContent={'center'}>
        {shoppingBags.some((shoppingBag) => shoppingBag.name === '') ? (
          <TextButton
            disabled={true}
            iconPath={'/icon/grey/plus.svg'}
            label={'レジ袋オプションを追加'}
            onClick={addShoppingBagRow}
          />
        ) : (
          <TextButton iconPath={'/icon/blue/plus.svg'} label={'レジ袋オプションを追加'} onClick={addShoppingBagRow} />
        )}
      </FlexRow>
    </div>
  )
}

export default ShoppingBagEditor
